export type MessageType =
  | 'text'
  | 'image'
  | 'video'
  | 'audio'
  | 'file'
  | 'location'
  | 'html'
  | 'custom'
  | 'quick-reply'
  | 'carousel'
  | 'button'
  | 'card'
  | 'list'
  | 'table'
  | 'template'
  | 'url'
  | 'loading';

export type userType = 'user' | 'bot';
export interface ChatMessage {
  id: string;
  type: MessageType;
  content: Record<string, any> | string;
  senderInitial?: string;
  from: userType;
  editable?: boolean;
  actions?: ('copy' | 'delete' | 'edit' | 'download')[];
  timestamp?: Date;
  feedback?: boolean;
}

export interface chatHistory {
  sessionId: string;
  conversation_history?: Record<string, any>[];
  messages: Record<string, any>[];
}

export enum SenderType {
  User = 'user',
  Bot = 'bot',
}

export enum MessageFunctionType {
  Text = 'text',
  Table = 'table',
  Loading = 'loading',
}

export enum FeedbackType {
  Like = 'like',
  Dislike = 'dislike',
}

export const CHAT_HISTORY_KEY = 'chatHistory';

export const CURRENT_CHAT_SESSION_ID = 'currentChatSessionId';

export enum EntityType {
  Lease = 'lease',
  Availability = 'availability',
  Property = 'property',
  Company = 'company',
  Tim = 'tim',
}
